/**
 * returns the profile or undefined, if there are no profiles
 */
export const getProfile = state => profileId =>
  state.profiles.data.find(profile => profile.id === profileId);
